// ---------------- DATE HELPERS ----------------

export function toISODateInput(d) {
  if (!d) return '';
  const x = new Date(d);
  const yyyy = x.getFullYear();
  const mm = String(x.getMonth() + 1).padStart(2, '0');
  const dd = String(x.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function startOfMonth(d = new Date()) {
  const x = new Date(d);
  x.setDate(1);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function endOfMonth(d = new Date()) {
  const x = new Date(d);
  x.setMonth(x.getMonth() + 1, 0);
  x.setHours(23, 59, 59, 999);
  return x;
}

export function fmtTRDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);

  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');

  return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
}

// ---------------- MONEY ----------------

export function fmtTry(v) {
  const n = Number(v ?? 0);
  if (!Number.isFinite(n)) return '0 ₺';
  return `${n.toLocaleString('tr-TR')} ₺`;
}

// ---------------- STATUS / BADGE ----------------

export function scoreChip(noShow, cancelled) {
  if (Number(noShow) > 0) return { label: 'Kritik', color: 'error' };
  if (Number(cancelled) > 0) return { label: 'Dikkat', color: 'warning' };
  return { label: 'İyi', color: 'success' };
}

export function timeAgo(iso) {
  if (!iso) return { text: '—', tone: 'default' };

  const now = new Date();
  const at = new Date(iso);
  const diff = Math.floor((now - at) / 1000);

  if (diff < 60) return { text: `${diff} sn önce`, tone: 'info' };

  const min = Math.floor(diff / 60);
  if (min < 60) return { text: `${min} dk önce`, tone: 'warning' };

  const hr = Math.floor(min / 60);
  return { text: `${hr} saat önce`, tone: 'default' };
}

// ---------------- FETCH ----------------

export async function fetchJson(url) {
  const res = await fetch(url, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
